import moment from 'moment';

export default groupApptByDay;

/**
 * @name groupApptByDay
 * @description Function to group appointments by days on the calendar
 * @param {unknown} data Unknown
 * @return {array} Returns an array of sorted appointments by
 * day groups.
 */
function groupApptByDay(data) {
  let dayGroups = [
    [], [], [], [], [], [], []
  ];

  // Push to days array
  for (let v = 0; v < data.length; v++) {
    dayGroups[moment(data[v].appointment_datetime,
    'YYYY-MM-DDTHH:mm:ss').day()].push(data[v]);
  }
  return dayGroups;
}



// WEBPACK FOOTER //
// ./utils/group-appts-by-day.js